<template>
  <span
    v-if="isCyclic"
    :class="{
      'cyclic': true,
      'is-row-mode': rowMode,
      'is-error': loadingError,
      'is-loading': loadingData
    }"
    @click.stop.prevent="loadPeriodicityData"
    :title="loadingError ? $t('common.ui.loadingError') : null">
    <template v-if="loadingData">
      <span class="cyclic-loading-icon"></span>
    </template>
    <template v-else>
      {{ $t('common.ui.cycle') }} <span class="cyclic-icon"></span>
    </template>

    <span
      v-if="itemData.parent_id"
      class="parent-reservation"
      @click.stop.prevent="$bus.$emit('show-reservation-details-popup', itemData.parent_id)">
      <icon
        name="info-circle-alt"
        primaryColor="color-text-light"
        strokeColor="color-text-light"
        size="xxs" />
      <tooltip
        :text="$t('reservationDetails.reservationParentDetails') + '#' + itemData.parent_id" />
    </span>

    <info-box
      v-if="dataLoaded"
      :ref="'periodicity-' + itemData.id"
      :spacing="32"
      :position="infoBoxPosition"
      :parentSelectorWithOverflow="parentSelectorWithOverflow">
      <div slot="content">
        <small
          v-if="autoRenew"
          class="text-center"
          v-pure-html="$t('reservationForm.untilCancelInfo')">
        </small>
        <div
          v-for="(period, index) of periodicity"
          :class="{
            'info-box-period': true,
            'info-box-period-current': period.start_at === reservationDate
          }"
          :key="'info-box-period-' + period.id + '-' + index">
          <template v-if="contentMode === 'simple'">
            {{ period.start_at }}
          </template>
          <template v-else>
            <template v-if="reservationDate === period.start_at">
              {{ period.start_at }}
            </template>

            <a
              v-if="reservationDate !== period.start_at"
              href="#"
              @click.prevent.stop="showReservationDetails(period.id)">
              {{ period.start_at }}
            </a>
          </template>
        </div>
      </div>
    </info-box>
  </span>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';
import Tooltip from './../common/Tooltip';
import Vue from 'vue';

export default {
  name: 'periodicity-viewer',
  props: [
    'itemData',
    'infoBoxPosition',
    'parentSelectorWithOverflow',
    'rowMode',
    'contentMode',
    'isBlockedDate',
    'autoRenew'
  ],
  components: {
    'tooltip': Tooltip
  },
  computed: {
    isCyclic () {
      return this.itemData.has_periodicity;
    },
    reservationDate () {
      return this.itemData.start_at;
    }
  },
  data () {
    return {
      dataLoaded: false,
      loadingData: false,
      loadingError: false,
      periodicity: []
    }
  },
  methods: {
    showInfo (id) {
      this.$bus.$emit('body-clicked');

      setTimeout(() => {
        this.$refs[id].show();
      }, 0);
    },
    showReservationDetails (reservationID) {
      this.$bus.$emit('body-clicked');
      this.$bus.$emit('show-reservation-details-popup', reservationID, this.isBlockedDate ? 'blocking' : 'inquiry');
    },
    loadPeriodicityData () {
      this.loadingData = true;
      this.loadingError = false;

      if (this.dataLoaded) {
        this.showInfo('periodicity-' + this.itemData.id);
        this.loadingData = false;
        return;
      }

      let endpointBase = '/panel/calendar/get-periodicity/inquiry/';

      if (this.isBlockedDate) {
        endpointBase = '/panel/calendar/get-periodicity/blocked-termin/';
      }

      this.$http.get(endpointBase + parseInt(this.itemData.id)).then(response => {
        if (response.data.success) {
          this.periodicity = response.data.periodicity;
          this.dataLoaded = true;

          Vue.nextTick(() => {
            this.showInfo('periodicity-' + this.itemData.id);
          });
        } else {
          this.loadingError = true;
        }

        this.loadingData = false;
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, endpointBase + parseInt(this.itemData.id), this.$router, this.$bus, this.loadPeriodicityData.bind(this));
        this.loadingData = false;
        this.loadingError = true;
      });
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variables.scss';

.cyclic {
  color: $color-text-light;
  cursor: pointer;
  display: inline-block;
  font-size: 1.4rem;
  font-weight: 600;
  margin-right: .75rem;
  position: relative;

  &-icon {
    border-left: 3px solid $color-text-light;
    border-right: 3px solid $color-text-light;
    display: inline-block;
    height: 1.1rem;
    position: relative;
    top: .1rem;
    width: 2.1rem;

    &:after,
    &:before {
      background: $color-text-light;
      content: "";
      height: 1.1rem;
      left: .3rem;
      position: absolute;
      top: 0;
      width: .3rem;
    }

    &:after {
      left: .9rem;
    }
  }

  &.is-row-mode {
    margin: 3px 6px 0 12px;
  }

  &.is-loading {
    .cyclic-loading-icon {
      animation: spinner 1s infinite linear;
      border: 2px solid $color-text-light;
      border-left-color: transparent;
      border-radius: 50%;
      display: inline-block;
      height: 1.4rem;
      position: relative;
      transform: rotate(0deg);
      top: 2px;
      width: 1.4rem;
    }
  }

  &.is-error {
    color: $color-danger;

    .cyclic-icon {
      border-left-color: $color-danger;
      border-right-color: $color-danger;

      &:after,
      &:before {
        background: $color-danger;
      }
    }
  }

  .text-center {
    display: block;
    text-align: center;
  }

  .parent-reservation {
    margin-left: 1rem;
    position: relative;
    top: 1px;

    &:hover {
      .tooltip {
        opacity: 1;
        top: -3.5rem;
      }
    }
  }
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PeriodicityViewer.vue